import React from "react";
import loadable from "@loadable/component";
import CalendarIcon from "../../Icons/CalendarIcon";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import usePatchHook from "../../customHooks/usePatchHook";
import APIS from "../../constant/Endpoint";
import WelcomeIcon from "../../Icons/WelcomeIcon";
import CreateIcon from "../../Icons/CreateIcon";
import { useParams } from "react-router-dom";
import useGetHook from "../../customHooks/useGetHook";

const EditBranchComponent = loadable(
  () => import("../../components/Branch/EditBranch"),
);
const EditBranch = () => {
  const id = useParams().id;
  const {
    data: branchData,
    isLoading: branchLoading,
    refetch,
  } = useGetHook({
    queryKey: ["branch", `branch-${id}`],
    url: `${APIS.BRANCH}${id}/`,
    params: {},
  });
  const { mutateAsync: patchUser } = usePatchHook({
    queryKey: ["branch", id],
    navigateURL: "/branch",
  });
  const handleEditBranch = async (values: any, setError: any) => {
    const url = `${APIS.BRANCH}${id}/`;

    let formData = {
      ...values,
    };
    try {
      const res = await patchUser({ url, formData, setError });
      if (res.status == 201) {
        refetch();
      }
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Edit Branch
        </span>
      </div>
      <EditBranchComponent
        branchData={branchData}
        refetch={refetch}
        handleEditBranch={handleEditBranch}
        branchLoading={branchLoading}
      />
    </>
  );
};

export default EditBranch;
